export default "__VITE_ASSET__f5425ff4__"